module.exports = __webpack_public_path__ + "static/media/book_javed_nama_persian_9.733ccb11.jpg";